import {  Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { SupplierMappingAdapter } from './dto/supplier-mapping.adapter';
import { SupplierCreation } from './supplier-creation.entity';
import { SupplierMappingController } from './supplier-mapping.controller';
import { SupplierMappingService } from './supplier-mapping.service';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { JwtModule, JwtService } from '@nestjs/jwt';

@Module({
  imports: [
    
    TypeOrmModule.forFeature([SupplierCreation]),
    JwtModule.register({
      secret:'supplier',
      signOptions: { expiresIn: '1d' },
    }),
    ],
  controllers: [SupplierMappingController],
  providers: [SupplierMappingAdapter,SupplierMappingService,ApplicationExceptionHandler,JwtModule],
  exports:[SupplierMappingService,JwtModule]
})
export class SupplierMappingModule {
}
